export default __webpack_public_path__ + "static/media/GetInTouch.5fc92e2c.png";